import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL;

const client = axios.create({ baseURL: `${API}/api` });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d.msg || d);
};

export const adminApi = {
  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  logout: () => client.post("/auth/logout"),
  changePassword: (current_password, new_password) => client.post("/auth/change-password", { current_password, new_password }),
  settings: () => client.get("/admin/settings").then((r) => r.data),
  saveSettings: (body) => client.put("/admin/settings", body).then((r) => r.data),
  games: () => client.get("/admin/games").then((r) => r.data),
  createGame: (body) => client.post("/admin/games", body).then((r) => r.data),
  updateGame: (id, body) => client.put(`/admin/games/${id}`, body).then((r) => r.data),
  deleteGame: (id) => client.delete(`/admin/games/${id}`),
  reorder: (list, ids) => client.post("/admin/games/reorder", { list, ids }),
  move: (id, position) => client.post(`/admin/games/${id}/move`, { position }).then((r) => r.data),
  indexingStatus: () => client.get("/admin/indexing/status").then((r) => r.data),
  indexingSubmitAll: () => client.post("/admin/indexing/submit-all").then((r) => r.data),
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
};

export const resolveUrl = (u) => (u && u.startsWith("/api/") ? `${API}${u}` : u);
